export const SET_LOADING_DATA = '@trading/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@trading/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@trading/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@trading/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@trading/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@trading/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@trading/SAVE_REQUEST';
export const SAVE_SUCCESS = '@trading/SAVE_SUCCESS';

export const DELETE_ITEM = '@trading/DELETE_ITEM';
export const EDIT_ITEM = '@trading/EDIT_ITEM';

export const SET_PAGE = '@trading/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@trading/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@trading/SET_ORDER';
export const SET_ORDERBY = '@trading/SET_ORDEBY';
